import type { TvShow, Vod } from '@setplex/tria-api'
import type { RecommendationItem } from '../index.h'

import { isPaid } from '~/features/payment'
import { extendMediaItemByLabelPrice } from '~/shared/tools'

export function mapVodItem(vod: Vod): RecommendationItem {
  const withPrice = extendMediaItemByLabelPrice(vod)

  return {
    id: vod.id,
    contentType: 'vod',
    name: vod.name,
    posterUrl: vod.imageHorizontalUrl,
    detailPath: `/content/movie/${vod.id}?categoryId=0`,
    locked: vod.locked,
    blockedByAcl: vod.blockedByAcl,
    rented: withPrice.rented,
    labelPrice: withPrice.labelPrice,
    paid: isPaid(vod),
  }
}

export function mapShowItem(show: TvShow): RecommendationItem {
  const withPrice = extendMediaItemByLabelPrice(show)

  return {
    id: show.id,
    contentType: 'show',
    name: show.name,
    posterUrl: show.landscapeImageUrl,
    detailPath: `/content/series/${show.id}?categoryId=0`,
    locked: show.locked,
    blockedByAcl: show.blockedByAcl,
    rented: withPrice.rented,
    labelPrice: withPrice.labelPrice,
    vertical: show.vertical,
    paid: isPaid(show),
  }
}
